import { render, staticRenderFns } from "./CoInput.vue?vue&type=template&id=0875a1b4&scoped=true&"
import script from "./CoInput.vue?vue&type=script&lang=ts&"
export * from "./CoInput.vue?vue&type=script&lang=ts&"
import style0 from "./CoInput.vue?vue&type=style&index=0&id=0875a1b4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0875a1b4",
  null
  
)

export default component.exports